// extracted by mini-css-extract-plugin
export default {"AnchorTo":"index__AnchorTo--wKeCI","anchorTo":"index__AnchorTo--wKeCI","Anchor":"index__Anchor--EJd5F","anchor":"index__Anchor--EJd5F"};